var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "127", height: "126", viewBox: "0 0 127 126", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M63.168 0C28.281 0 0 28.06 0 62.67s28.281 62.67 63.168 62.67 63.169-28.06 63.169-62.67S98.055 0 63.168 0zm0 119.03c-31.49.02-57.039-25.29-57.062-56.53C6.083 31.26 31.593 5.91 63.085 5.89c31.49-.02 57.038 25.29 57.061 56.53v.08c0 31.22-25.51 56.53-56.978 56.53zM90.162 62.5a2.98 2.98 0 0 1-2.99 2.97H63.169a2.98 2.98 0 0 1-2.99-2.97V26.78c0-1.64 1.34-2.96 2.99-2.96 1.651 0 2.99 1.32 2.99 2.96v32.71h21.056a2.98 2.98 0 0 1 2.99 2.97l-.041.04z", fill: "#0061AC" })
  );
});